module.exports = __webpack_public_path__ + "static/media/1.All kinds of Copper Cables.d86f3ae8.jpg";